resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    Switch

    A toggle (on/off) switch. The switch allows only two values, on or off. The values correspond to
    true and false, respectively. The labels for the switch are hidden by default, but available to
    assistive technologies. Both the on/off values and labels can be customized.

    Note that this.node does not refer to the element with (data-mogo-ui="Switch") if that element is not
    an <input> element but to a child <input> node that this script creates. To access Switch instance
    methods, you need to call mogo() on the div with (class="mogo-ui-switch__input") inside the
    (data-mogo-ui="Switch") element to get a reference to the Switch instance.

    Arguments:

      placeholder (optional) [String]:
        The label for the switch. Eg. "Lights".

      disabled (optional) [Boolean]:
        Defaults to false. Sets whether or not the switch is disabled and cannot be turned on/off.

      checked (optional) [Boolean]:
        Defaults to false. Sets whether or not the switch is in the "on" position.

      onLoadCallback (optional) [Function]:
        Defaults to null. Set a callback function, where a function (X) will be passed to this callback.
        When the state of the switch is changed, the switch will go to a loading state. When function X
        is called with a true or false argument, the state of the switch will be complete (true) or
        reverted (false).

      showLabels (optional) [Boolean]:
        Defaults to false. Shows or hides on/off labels to the left and right side of the switch.

      onLabel (optional) [String]:
        Defaults to "On". The label for the "on" or checked state.

      offLabel (optional) [String]:
        Defaults to "Off". The label for the "off" or unchecked state.


*/
function Switch() {
  this.extends = [_ComponentDataBind];
  this.node = null;
  this.id = null;

  this.placeholder = ""; // label for field; must have placeholder AND/OR on and off labels
  this.disabled = false;
  this.checked = false;
  this.onLoadCallback = null; // callback for loading state
  this.showLabels = false; // Show labels for on/off state
  this.onLabel = "On"; // Label for "on" state. Defaults to "on".
  this.offLabel = "Off"; // Label for "off" state. Defaults to "off".

  this.init = function() {
    // Create structure
    if (this.node.tagName.toLowerCase() === "input") {
      this.containerDiv = document.createElement("div");
    } else {
      this.containerDiv = this.node;
      this.node = document.createElement("input");
      this.node.setAttribute("id", this.containerDiv.getAttribute("id"));
      this.containerDiv.removeAttribute("id");
    }
    if (this.placeholder.trim() !== "") {
      this.labelDiv = document.createElement("label");
      this.containerDiv.insertBefore(this.labelDiv, this.containerDiv.firstChild);
    }
    this.containerDiv.appendChild(this.node);
    this.uiContainerDiv = document.createElement("div");
    this.containerDiv.appendChild(this.uiContainerDiv);
    this.offLabelDiv = document.createElement("div");
    this.uiContainerDiv.appendChild(this.offLabelDiv);
    this.onLabelDiv = document.createElement("div");
    this.uiContainerDiv.appendChild(this.onLabelDiv);
    this.uiDiv = document.createElement("div");
    this.uiContainerDiv.appendChild(this.uiDiv);
    this.switchDiv = document.createElement("div");
    this.uiDiv.appendChild(this.switchDiv);
    this.switchDecoDiv = document.createElement("div");
    this.uiDiv.appendChild(this.switchDecoDiv);
    this.switchDecoOnDiv = document.createElement("div");
    this.switchDecoDiv.appendChild(this.switchDecoOnDiv);
    this.switchDecoOffDiv = document.createElement("div");
    this.switchDecoDiv.appendChild(this.switchDecoOffDiv);
    this.loadingDiv = document.createElement("div");
    this.switchDiv.appendChild(this.loadingDiv);

    // Set node attributes
    this.node.setAttribute("type", "checkbox");
    this.node.setAttribute("role", "switch");
    this.node.setAttribute("aria-checked", this.checked ? "true" : "false");
    if (!this.placeholder && this.showLabels) {
      this.node.setAttribute("aria-labelledby", this.id + "__ui-container");
    }
    this.node.addClass("a11y__hidden-content");
    this.node.addClass("mogo-ui-switch__input");
    this.containerDiv.addClass(this.checked ? "checked" : "");
    if (this.labelDiv) {
      this.containerDiv.addClass("label-primary");
      this.labelDiv.addClass("mogo-ui-switch__label");
      if (!this.showLabels) {
        this.labelDiv.setAttribute("for", this.id);
      }
    }
    if (this.showLabels) {
      this.containerDiv.addClass("labels-primary");
    }
    this.uiContainerDiv.addClass("mogo-ui-switch__ui-container");
    this.uiContainerDiv.setAttribute("id", this.id + "__ui-container");
    this.loadingDiv.addClass("progress-spinner");
    this.loadingDiv.addClass("mogo-ui-switch__loading");
    this.loadingDiv.setAttribute("aria-hidden", "true");
    this.uiDiv.addClass("mogo-ui-switch__ui");
    this.switchDiv.addClass("mogo-ui-switch__switch");
    this.switchDecoDiv.addClass("mogo-ui-switch__switch-decoration");
    this.switchDecoDiv.setAttribute("aria-hidden", "true");
    this.switchDecoOnDiv.addClass("mogo-ui-switch__switch-decoration--on");
    this.switchDecoOffDiv.addClass("mogo-ui-switch__switch-decoration--off");
    this.offLabelDiv.addClass("mogo-ui-switch__label--off");
    this.onLabelDiv.addClass("mogo-ui-switch__label--on");

    // Set content
    if (this.labelDiv) {
      this.labelDiv.innerHTML = this.placeholder;
    }
    if (this.showLabels) {
      this.offLabelDiv.innerHTML = this.offLabel + '<span class="a11y__hidden-content">(Off State)</span>';
      this.onLabelDiv.innerHTML = this.onLabel + '<span class="a11y__hidden-content">(On State)</span>';
    }
    this.loadingDiv.innerHTML = '<span class="a11y__hidden-content">Loading</span>'
    this.switchDecoOnDiv.innerHTML = "I";
    this.switchDecoOffDiv.innerHTML = "O";

    // Connections
    this.node.addEventListener("change", this._onNodeChange.bind(this));
    this.node.addEventListener("focus", this._onFocus.bind(this));
    this.node.addEventListener("blur", this._onBlur.bind(this));
    this.uiDiv.addEventListener("click", this._onClick.bind(this));

    this._super();
  };

  this.initAllReady = function() {
    this._super();

    // Style and show
    this.containerDiv.addClass("mogo-ui-switch");
  };

  this.setChecked = function(value) {
    if (typeof value === "boolean") {
      var newValue = value != this.node.checked ? true : false;
      this.checked = value;
      this.node.checked = value;
      this._updateUI();
      if (newValue) this._dispatchCallback();
    }
  };

  this.val = function(value) {
    if (value == null) {
      if (this.node.checked)
        return this.node.value;
      else
        return null;
    } else {
      this.setChecked(value);
    }
  };

  this._onClick = function(evt) {
    if (evt.target.tagName !== "INPUT" && !this.containerDiv.classList.contains("loading")) {
      this.setChecked(!this.node.checked);
    }
  };

  this._onNodeChange = function() {
    this.checked = this.node.checked;
    this._updateUI();
  };

  this._onFocus = function() {
    this.containerDiv.addClass("focused");
  };

  this._onBlur = function() {
    this.containerDiv.removeClass("focused");
  };

  this._updateUI = function() {
    if (this.checked) {
      this.containerDiv.addClass("checked");
    } else {
      this.containerDiv.removeClass("checked");
    }
    this.node.setAttribute("aria-checked", this.checked ? "true" : "false");
  };

  this._dispatchCallback = function() {
    if (typeof this.onLoadCallback === "function") {
      this.onLoadCallback(this._onUpdateCallback.bind(this));
      this.containerDiv.addClass("loading");
    }
  };

  this._onUpdateCallback = function(success) {
    this.containerDiv.removeClass("loading");
    if (!success) {
      this.checked = !this.checked;
      this.node.checked = this.checked;
      this._updateUI();
    }
  };

  this.destroy = function() {
    this._super();
  };
}
